import { useEffect } from "react";
import ReactTooltip from "react-tooltip";

export function useTooltipRebuild(...dependencyArray){
	useEffect(()=>{
		ReactTooltip.rebuild();

		return ()=>ReactTooltip.hide();
	}, dependencyArray);
}
